import { Navigate, useLocation } from "react-router-dom";
import { isEmpty } from "./../helper/helperGeneral";
import { useAuth } from "./../components/authProvider";
import ComLoading from './comLoading';

const RequireAuth = ({ children }) => {
    const { authUser, authLoading } = useAuth();
    const location = useLocation();

    if (authLoading === true) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-slate-100 to-blue-100 text-slate-600">
                <ComLoading />
            </div>
        );
    }
    else {
        if (isEmpty(authUser)) {
            return <Navigate to="/login" state={{ from: location }} replace />
        }
        else return children;
    }
};

export default RequireAuth;